import rebrand from '../../../config/rebrand';
import * as TokenRequest from '../token';

const KLICKART_AUTH_URI = rebrand.urls.KLICKART_AUTH_URI;

const shouldUpdateToken = error => error.response.status === 401 && !error.config.tokenUpdated;

export default axiosInstance => error => {
  const requestConfig = error.config;

  if (!shouldUpdateToken(error)) {
    return Promise.reject(error);
  }

  return TokenRequest.get()
    .then(token => {
      requestConfig.tokenUpdated = true;
      requestConfig.headers.Authorization = `token=${token}`;

      return axiosInstance(requestConfig);
    })
    .catch(() => {
      window.location = KLICKART_AUTH_URI;

      return Promise.reject(error);
    });
};



/** WEBPACK FOOTER **
 ** ./src/helpers/request/interceptors/token.js
 **/